import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classNames from "classnames";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";
import { default as Item } from "./GlobalFooterItem";
import { default as rehydrator } from "./GlobalFooter.rehydrator";
import GlobalFooterLogoContainer from "./GlobalFooterLogoContainer";
import GlobalPreFooterContainer from "./GlobalPreFooterContainer";
import GlobalFooterUnder from "./GlobalFooterUnder";

var GlobalFooter = /*#__PURE__*/function (_Component) {
  _inherits(GlobalFooter, _Component);

  var _super = _createSuper(GlobalFooter);

  /* eslint-disable max-len */

  /* eslint-enable max-len */
  function GlobalFooter(props) {
    var _this;

    _classCallCheck(this, GlobalFooter);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleWindowResize", function () {
      if (window && window.innerWidth) {
        _this.setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            isMobile: window.innerWidth < _this.mobileScreenBreakpoint
          });
        });
      }
    });

    _this.getClassName = getClassNameFactory(GlobalFooter.displayName);
    _this.ref = null;
    _this.mobileScreenBreakpoint = 768;
    _this.state = {
      expanded: false,
      isMobile: false
    };
    return _this;
  }

  _createClass(GlobalFooter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleWindowResize();
      window.addEventListener("resize", this.handleWindowResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleWindowResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.ref) {
        return;
      }

      if (this.state.expanded) {
        var componentBottomY = this.ref.offsetTop + this.ref.offsetHeight; // if bottom of component below viewport

        if (componentBottomY > window.innerHeight) {
          this.ref.scrollIntoView(true);
        }
      }
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand() {
      this.setState({
        expanded: !this.state.expanded
      });
    }
  }, {
    key: "getItems",
    value: function getItems(type) {
      var items = [];
      React.Children.forEach(this.props.children, function (child) {
        if (child.type === type) {
          items.push(child);
        }
      });
      return items;
    }
  }, {
    key: "getListTypeFooterItems",
    value: function getListTypeFooterItems() {
      var _this$props$children$;

      var items = [];
      React.Children.forEach((_this$props$children$ = this.props.children.props) === null || _this$props$children$ === void 0 ? void 0 : _this$props$children$.children, function (child) {
        if (child.type === "li") {
          items.push(child);
        }
      });
      return items;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          logoHref = _this$props.logoHref,
          logoText = _this$props.logoText,
          target = _this$props.target,
          ariaLabel = _this$props.ariaLabel;
      var _this$state = this.state,
          expanded = _this$state.expanded,
          isMobile = _this$state.isMobile;
      var items = this.getItems(Item);
      var footerItems = items.length > 0 ? items : this.getListTypeFooterItems();
      var topColumns = this.getItems(GlobalPreFooterContainer);
      var footerUnder = this.getItems(GlobalFooterUnder);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          modifiers: classNames()
        }),
        "data-logo-href": logoHref,
        "data-logo-text": logoText,
        "data-rehydratable": getRehydratableName(GlobalFooter.displayName),
        ref: function ref(_ref) {
          return _this2.ref = _ref;
        }
      }, topColumns.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "columns"
        })
      }, topColumns), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "inner"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "innerContent"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "top"
        })
      }, /*#__PURE__*/React.createElement(GlobalFooterLogoContainer, {
        className: this.getClassName({
          descendantName: "logo"
        }),
        href: logoHref,
        target: target,
        ariaLabel: ariaLabel
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "logoInner"
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "logoLabel",
          utilities: "hiddenVisually"
        })
      }, logoText)))), /*#__PURE__*/React.createElement("nav", {
        "aria-label": "global footer",
        role: "navigation"
      }, isMobile && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "mobileHeader"
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "mobileTitle"
        })
      }, "Site links"), /*#__PURE__*/React.createElement("button", {
        className: this.getClassName({
          descendantName: "mobileIconButton"
        }),
        onClick: this.toggleExpand.bind(this),
        "aria-haspopup": true,
        "aria-expanded": expanded,
        title: "Expand site links menu",
        "aria-label": "Expand site links menu"
      }, expanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, {
        className: this.getClassName({
          descendantName: "mobileIcon"
        })
      }) : /*#__PURE__*/React.createElement(ChevronDownIcon, {
        className: this.getClassName({
          descendantName: "mobileIcon"
        })
      }))), /*#__PURE__*/React.createElement("ul", {
        className: this.getClassName({
          descendantName: "items",
          modifiers: classNames({
            expanded: expanded
          })
        }),
        "data-rehydratable-children": true
      }, footerItems)))), footerUnder.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: isMobile && !expanded ? "underHidden" : "under"
        })
      }, footerUnder)));
    }
  }]);

  return GlobalFooter;
}(Component);

_defineProperty(GlobalFooter, "displayName", "GlobalFooter");

_defineProperty(GlobalFooter, "rehydrator", rehydrator);

_defineProperty(GlobalFooter, "Item", Item);

_defineProperty(GlobalFooter, "propTypes", {
  /**
   * GlobalFooterItems representing the links
   */
  children: PropTypes.node.isRequired,

  /**
   * URL for the logo link
   */
  logoHref: PropTypes.string,

  /**
   * link target for the logo link
   */
  target: PropTypes.string,

  /**
   * aria label for the logo link
   */
  ariaLabel: PropTypes.string,

  /**
   * Alternative text for the logo
   */
  logoText: PropTypes.string
});

_defineProperty(GlobalFooter, "defaultProps", {
  logoText: "Thomson Reuters",
  logoHref: null
});

export default GlobalFooter;